const getPasswordLevelAndEncodePassword = (password) => {
  return new Promise((res) => {
    window.HiyaJSBridge.callHandler(
      "getPasswordLevelAndEncodePassword",
      { password },
      ({ level = "", encodePassword = "" }) => {
        res({ level, encodePassword });
      }
    );
  });
};
export {
  getPasswordLevelAndEncodePassword
};
